import { render, staticRenderFns } from "./JuournalListComponent.vue?vue&type=template&id=3dc8262c&"
import script from "./JuournalListComponent.vue?vue&type=script&lang=js&"
export * from "./JuournalListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports